<template>
  <div class="smart-banner" v-if="hasOpened">
    <div class="close-button" @click="() => { hasOpened = !hasOpened }">
      <v-btn rounded>
        <v-icon>close</v-icon>
      </v-btn>
    </div>
    <!-- Android uygulaması görseli mobil için --!>
<!--    <div class="banner-container">-->
<!--      <img class="banner-phone" :src="require(`../../assets/${getMobileOS()}.png`)" alt="phone">-->
<!--      <div class="banner-inner">-->
<!--        <h1 class="smart-header">{{ getMobileOS() }} uygulamamızı indirin!</h1>-->
<!--        <v-btn @click="downloadApplication">İndir!</v-btn>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
  export default {
    name: 'SmartBanner',
    data: () => ({
      hasOpened: true,
    }),
    methods: {
      getMobileOS() {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        if (/android/i.test(userAgent)) return 'Android';
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) return 'iOS';
        return '';
      },
      downloadApplication() {
        const device = this.getMobileOS();
        const android = 'https://play.google.com/store/apps/details?id=com.vatan.sms&hl=en_US';
        const ios = 'https://apps.apple.com/tr/app/vatansms-mobile/id1533629616';

        window.open(device === 'iOS' ? ios : android, '__blank');
      },
    },
  };
</script>

<style>
  @media screen and (min-width: 576px) {
    .smart-banner{
      display: none;
    }
  }

  .smart-banner{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    padding: 72px 16px 0;
    box-sizing: border-box;
    background: linear-gradient(0deg, rgba(0,0,0,0.75) 25%, rgba(255,255,255,0) 100%);
    z-index: 900;
    color: #FFF;
  }

  .close-button{
    position: absolute;
    right: 16px;
    top: 48px;
  }

  .banner-container {
    display: flex;
    flex-direction: row;
  }

  .banner-phone{
    width: 40%;
    margin-right: 16px;
  }

  .banner-inner{
    flex: auto
  }

  .smart-header{
    font-size: 20px;
    font-weight: bold;
  }
</style>
